/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class ProcessConfigurationService extends services.DataService<Wars.Domain.Model.ProcessConfiguration> {

        private logType: string = "ProcessConfigurationService";

        constructor(injectedBreeze: typeof breeze, $q: angular.IQService, private $http: angular.IHttpService) {
            super(injectedBreeze, $q);
        }

        public createCondition(field: Wars.Domain.Model.Field): models.Condition {
            var condition = <models.Condition>(this.createNewEntity("Condition", { field: field }));
            condition.expression = <any>this.createNewEntity("GroupExpression");
            services.WarsLogger.logDebug("Creating Condition", this.logType, condition);
            return condition;
        }

        public createNewCondition(): models.Condition {
            var condition = this.createNewEntity<models.Condition>("Condition");
            condition.name = '';
            condition.expression = this.createGroupExpression();
            services.WarsLogger.logDebug("Creating New Condition", this.logType, condition);
            return condition;
        }

        public createGroupExpression(): Wars.Domain.Model.Conditions.GroupExpression {
            var exp = this.createNewEntity<Wars.Domain.Model.Conditions.GroupExpression>("GroupExpression");
            exp.expressionType = Wars.Domain.Model.Codes.Enums.ExpressionType.Group;

            return exp;
        }

        public getRelatedProcessTypeClaims(processType: string): angular.IPromise<Wars.Domain.Model.ClaimDefinition[]> {
            var d = this.$q.defer();

            var p1 = breeze.Predicate.create('processType_id', '==', processType);

            const query = this.breezeModule.EntityQuery
                .from("ProcessConfigurations")
                .where(p1)
                .expand("myClaims");

            this.executeQuery(query).then(r => {
                var processConfig = Enumerable.from(r).single(x=>x.configurationStatus == Wars.Domain.Model.Codes.Enums.ConfigurationStatus.Active);
                d.resolve(processConfig.myClaims);
            });

            return d.promise;
        }

        public getById(id: string): ng.IPromise<Wars.Domain.Model.ProcessConfiguration> {
            const query = this.breezeModule.EntityQuery
                .from("ProcessConfigurations")
                .where("id", "==", id);

            return this.fetch(query);
        }

        public getProcessConfigurationEagerLoadConditions(id: string): ng.IPromise<Wars.Domain.Model.ProcessConfiguration> {
            const query = this.breezeModule.EntityQuery
                .from("ProcessConfigurations")
                .where("id", "==", id)
                .expand('myConditions.expression, myConditions.tags');

            return this.fetch(query);
        }

        public getProcessConfigurationEagerEditFormParameters(id: string): ng.IPromise<Wars.Domain.Model.ProcessConfiguration> {
            const query = this.breezeModule.EntityQuery
                .from("ProcessConfigurations")
                .where("id", "==", id)
                .expand('myConditions.expression, myConditions.tags, myPaymentConfigurations');

            return this.fetch(query);
        }

        public getProcessConfigurationEagerLoadCalculations(id: string): ng.IPromise<Wars.Domain.Model.ProcessConfiguration> {
            const query = this.breezeModule.EntityQuery
                .from("ProcessConfigurations")
                .where("id", "==", id)
                .expand('myCalculations');

            return this.fetch(query);
        }

        public getProcessConfigurationEagerLoadPaymentInfo(id: string): ng.IPromise<Wars.Domain.Model.ProcessConfiguration> {
            var expand = "myPaymentConfigurations.myCustomActionInputs.myTreeItem, " +
                "myPaymentConfigurations.myPaymentRequestFormValueLookup.myTreeItem, " +
                "myPaymentConfigurations.amountTreeItem, " +
                "myPaymentConfigurations.myMappings.treeItem, " +
                "myPaymentConfigurations.myMappings.customInfo, " +
                "myPaymentConfigurations.myPaymentCustomInformation.valueCalculation";

            const query = this.breezeModule.EntityQuery
                .from("ProcessConfigurations")
                .where("id", "==", id)
                .expand(expand);

            return this.fetch(query);
        }

        public getProcessConfigurationWithForms(id: string): ng.IPromise<Wars.Domain.Model.ProcessConfiguration> {
            const query = this.breezeModule.EntityQuery
                .from("ProcessConfigurations")
                .where("id", "==", id)
                .expand('myForms, myProcessType');

            return this.fetch(query);
        }

        public getProcessConfigEagerLoadProcessType(id: string): ng.IPromise<Wars.Domain.Model.ProcessConfiguration> {
            const query = this.breezeModule.EntityQuery
                .from("ProcessConfigurations")
                .where("id", "==", id)
                .expand('myProcessType');

            return this.fetch(query);
        }

        public getProcessConfigurationForTree(id: string): ng.IPromise<Wars.Domain.Model.ProcessConfiguration> {
            var expandString = "myForms.mySteps.objectSchema, " +
                "myForms.formSchema.properties.typeSchema.properties.typeSchema.properties, " +
                "myCalculations.valueOperation, " +
                "myConditions, " +
                "myClaims, " +
                "myConstants, " +
                "myEmailGroups, " +
                "myStaticDocuments, " +
                "myTimeTrackerContainers.myTimeTracker, " +
                "myInterProcessApis.myOutputSchema.properties, " +
                "myCodeGroups.codes, " +
                "myRelatedClaimProcessTypes.relatedClaims";

            const query = this.breezeModule.EntityQuery
                .from("ProcessConfigurationsLazy")
                .where("id", "==", id)
                .expand(expandString);

            return this.fetch(query);
        }

        public getProcessConfigurationExpandFieldsAndEmailConfigs(id: string): ng.IPromise<Wars.Domain.Model.ProcessConfiguration> {
            var expand = "myForms.mySteps.formSections.fields.schemaProperty.codeGroup, " +
                "myEmailConfigurations.documents";

            const query = this.breezeModule.EntityQuery
                .from("ProcessConfigurationsLazy")
                .where("id", "==", id)
                .expand(expand);

            return this.fetch(query);
        }

        public getWorkflowExpandFieldsAndPdfBindings(id: string): ng.IPromise<Wars.Domain.Model.ProcessConfiguration> {
            const query = this.breezeModule.EntityQuery
                .from("ProcessConfigurationsLazy")
                .where("id", "==", id)
                .expand('myForms.mySteps.formSections.fields.schemaProperty.codeGroup, myPdfBindings');

            return this.fetch(query);
        }

        public getExpandFields(id: string): ng.IPromise<Wars.Domain.Model.ProcessConfiguration> {
            var expand = "myForms.mySteps.objectSchema, " +
                "myForms.mySteps.formSections.fields.schemaProperty, " +
                "myForms.mySteps.formSections.fields.autoCompleteConfiguration.processType";
            const query = this.breezeModule.EntityQuery
                .from("ProcessConfigurationsLazy")
                .where("id", "==", id)
                .expand(expand);

            return this.fetch(query);
        }

        public getFieldsAndVariables(id: string): ng.IPromise<Wars.Domain.Model.ProcessConfiguration> {
            const query = this.breezeModule.EntityQuery
                .from("ProcessConfigurationsLazy")
                .where("id", "==", id)
                .expand('myForms.mySteps.formSections.objectSchema, myForms.mySteps.formSections.fields.schemaProperty, processDataSchema.properties.typeSchema.properties');

            return this.fetch(query);
        }

        public loadProcessConfigurationStatusGroup(processConfigId: string): ng.IPromise<Wars.Domain.Model.ProcessConfiguration> {
            const query = this.breezeModule.EntityQuery
                .from("ProcessConfigurations")
                .where('id', '==', processConfigId)
                .expand('myStatusCodeGroup.myStatuses.myStates');

            return this.fetch(query);
        }

        public loadProcessConfigurationDocumentTypes(appConfigId: string): ng.IPromise<Wars.Domain.Model.ProcessConfiguration> {
            var d = this.$q.defer();

            const query = this.breezeModule.EntityQuery
                .from("ProcessConfigurations")
                .where('id', '==', appConfigId)
                .expand('documentTypeCodeGroup.codes');

            this.executeQuery(query).then(
                (appConfigs) => d.resolve(appConfigs[0]));

            return d.promise;
        }

        public loadFieldGroup(field: Wars.Domain.Model.Field) {
            const query = this.breezeModule.EntityQuery
                .from("Fields")
                .where('id', '==', field.id)
                .expand('schemaProperty.codeGroup.codes');

            this.executeQuery(query);
        }

        public loadFieldExcludes(field: Wars.Domain.Model.Field) {
            const query = this.breezeModule.EntityQuery
                .from("Fields")
                .where('id', '==', field.id)
            .expand("fieldExcludedStatuses.statusCode,fieldExcludedSystemCodes.systemCode, fieldExcludedStates.stateCode ");

            this.executeQuery(query);
        }

        public getScheduleResourceInstances(processConfigId: string): ng.IPromise<Wars.Domain.Model.Dtos.SchemaPropertyDto[]> {
            var d = this.$q.defer();
            this.$http.get('./api/ProcessConfiguration/' + processConfigId + "/ScheduleResourceInstances").then((result) => d.resolve(result.data));
            return d.promise;
        }

        public getPermitSubTypeInfo(processConfigId: string): ng.IPromise<Wars.Domain.Model.ProcessConfiguration> {
            var expand =
                "mySubTypeConfiguration.myProcessSubTypes.myCreateSecurityMatrix, " +
                "mySubTypeConfiguration.myProcessSubTypes.myCreateProcessAction, " +
                "mySubTypeConfiguration.myProcessSubTypes.myProcessClaimToGrantToProcessCreator, " +
                "myStatusCodeGroup.myStatuses.myStates";
                    

            const query = this.breezeModule.EntityQuery
                .from("ProcessConfigurations")
                .where('id', '==', processConfigId)
                .expand(expand);

            return this.fetch(query);
        }

        public version(id: string, versionName: string): ng.IPromise<any> {
            var params = {
                versionName: versionName
            };
            var handlerUrl = "api/ProcessConfiguration/" + id + "/Version";

            var result: ng.IPromise<any> = this.$http.post(handlerUrl, params)
                .then((response: any): ng.IPromise<any> => this.handlerResponded(response, params));

            return result;
        }

        public beginActivation(id: string): ng.IPromise<Wars.Domain.Model.Dtos.SimpleResult> {
            var handlerUrl = "api/ProcessConfiguration/" + id + "/BeginActivation";
            var params = {};
            var result: ng.IPromise<any> = this.$http.post(handlerUrl, params)
                .then((response: any): ng.IPromise<any> => this.handlerResponded(response, params));

            return result;
        }

        public getTopLevelSchemaProperties(processConfigId: string): ng.IPromise<Wars.Domain.Model.SchemaProperty[]> {
            var deferred = this.$q.defer();

            this.getFieldsAndVariables(processConfigId).then(
                (processConfig) => {
                    var processSchemaProperties = this.getTopLevelSchemaPropertiesInternal(processConfig);
                    deferred.resolve(processSchemaProperties);
                });

            return deferred.promise;
        }

        public getProcessSchemaProperties(processConfigId: string): ng.IPromise<Wars.Domain.Model.SchemaProperty[]> {
            var deferred = this.$q.defer();

            this.getFieldsAndVariables(processConfigId).then(
                (processConfig) => {
                    var processSchemaProperties = this.getProcessSchemaPropertiesInternal(processConfig);
                    deferred.resolve(processSchemaProperties);
                });

            return deferred.promise;
        }

        private getTopLevelSchemaPropertiesInternal(processConfig: Wars.Domain.Model.ProcessConfiguration): Wars.Domain.Model.SchemaProperty[] {
            var list = [];

            for (var formIndex = 0; formIndex < processConfig.myForms.length; formIndex++) {
                var currentForm = processConfig.myForms[formIndex];
                for (var stepIndex = 0; stepIndex < currentForm.mySteps.length; stepIndex++) {
                    var currentStep = currentForm.mySteps[stepIndex];
                    for (var sectionIndex = 0; sectionIndex < currentStep.formSections.length; sectionIndex++) {
                        var currentSection = currentStep.formSections[sectionIndex];
                        if (currentSection.objectSchema.isList) continue;
                        for (var fieldIndex = 0; fieldIndex < currentSection.fields.length; fieldIndex++) {
                            var currentField = currentSection.fields[fieldIndex];
                            list.push(currentField.schemaProperty);
                        }
                    }
                }
            }

            if (processConfig.processDataSchema && processConfig.processDataSchema.properties) {
                list = list.concat(processConfig.processDataSchema.properties);
            }

            return list;
        }

        private getProcessSchemaPropertiesInternal(processConfig: Wars.Domain.Model.ProcessConfiguration): Wars.Domain.Model.SchemaProperty[] {
            var list = [];

            for (var formIndex = 0; formIndex < processConfig.myForms.length; formIndex++) {
                var currentForm = processConfig.myForms[formIndex];
                for (var stepIndex = 0; stepIndex < currentForm.mySteps.length; stepIndex++) {
                    var currentStep = currentForm.mySteps[stepIndex];
                    for (var sectionIndex = 0; sectionIndex < currentStep.formSections.length; sectionIndex++) {
                        var currentSection = currentStep.formSections[sectionIndex];
                        for (var fieldIndex = 0; fieldIndex < currentSection.fields.length; fieldIndex++) {
                            var currentField = currentSection.fields[fieldIndex];
                            let currentSchemaProperty = currentField.schemaProperty;
                            if (currentSchemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.ProcessId ||
                                currentSchemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.ProcessList) {
                                list.push(currentSchemaProperty);
                            }
                        }
                    }
                }
            }

            if (processConfig.processDataSchema && processConfig.processDataSchema.properties) {
                list = list.concat(this.getProcessSchemaPropertiesRecursively(processConfig.processDataSchema.properties));
            }

            return list;
        }

        private getProcessSchemaPropertiesRecursively(schemaProperties: Wars.Domain.Model.SchemaProperty[]): Wars.Domain.Model.SchemaProperty[] {
            var list = [];

            for (var topLevelIndex = 0; topLevelIndex < schemaProperties.length; topLevelIndex++) {
                let currentSchemaProperty = schemaProperties[topLevelIndex];
                if (currentSchemaProperty.typeSchema !== null) {
                    list = list.concat(this.getProcessSchemaPropertiesRecursively(currentSchemaProperty.typeSchema.properties));
                } else {
                    if (currentSchemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.ProcessId ||
                        currentSchemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.ProcessList) {
                        list.push(currentSchemaProperty);
                    }
                }
            }
            return list;
        }
    }
}

warsApp.registerService('ProcessConfigurationService', ['breeze', '$q', '$http']);